<template>
  <div class="twitter-feed">
    <div v-in-viewport.once class="text--center marg--bottom twitter-feed__title transition">
      <h2>
        #WeArt<span>GTG</span>
      </h2>
      <p>
        <b>Tout l’univers du GTG.</b><br class="mobile"> Ici, là, partout.
      </p>
    </div>
    <div class="row">
      <div class="col-10">
        <div class="row" v-if="filtered">
          <div class="col--third-marg">
            <div v-for="(social, index) in dataSocial" :key="social.id" v-if="index % 3 == 0">
              <tweet v-if="social.type == 'twitter'" :tweet="social" />  
              <insta v-if="social.type == 'instagram'" :insta="social" />  
            </div>
          </div>
          <div class="col--third-marg">
            <div v-for="(social, index) in dataSocial" :key="social.id" v-if="index % 3 == 1">
              <tweet v-if="social.type == 'twitter'" :tweet="social" />  
              <insta v-if="social.type == 'instagram'" :insta="social" />  
            </div>
          </div>
          <div class="col--third-marg">
            <div v-for="(social, index) in dataSocial" :key="social.id" v-if="index % 3 == 2">
              <tweet v-if="social.type == 'twitter'" :tweet="social" />  
              <insta v-if="social.type == 'instagram'" :insta="social" />  
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<style lang="scss">
.twitter-feed{
  margin-bottom: 8rem;
  h2{
    text-align: center;
    margin-bottom: 0;
    text-transform: none;
    margin-bottom: 1rem;
    span{
      color: $grey;
    }
  }

  &__title{
    @media #{$bp-sm}{
      margin-bottom: 5rem;
    }
  }
}
</style>

<script>
import Tweet from './Tweet.vue'
import Insta from './Insta.vue'
import InstaFeed from 'instafeed.js'
import moment from 'moment'

import 'whatwg-fetch'

export default {
  components: { Tweet, Insta },
  data() {
    return {
      insta: null,
      twitter: null,
      filtered: false,
      dataSocial: null
    };
  },
  methods: {
    filterDatas(){
      if( this.insta != null && this.twitter != null ){

        let data = this.twitter.concat(this.insta.slice(0,8))

        for( let i = 0, lg = data.length; i<lg; i++ ){
          if( data[i].created_time ){
            data[i].type = 'instagram'
            var mm = moment(parseInt(data[i].created_time)*1000)
            data[i].timestamp = mm.unix()//parseInt( data[i].created_time )
          }else{
            data[i].type = 'twitter'
            var m = moment.utc(data[i].created_at, "ddd MMM DD HH:mm:ss Z YYYY");
            data[i].timestamp = m.unix()
          }
        }

        data = data.sort((a,b)=>{
          if( a.timestamp > a.timestamp ){
            return 1
          }else{
            return -1
          }
        })
        
        this.dataSocial = data
        this.filtered = true
      }
    }
  },
  mounted() {
    fetch('/twitter.php')
    // fetch('/twitter-feed.json')
      .then(response => {
        return response.json()
      })
      .then(data => {
        this.twitter = data
        this.filterDatas()
      })
      .catch(err => {
        // Do something for an error here
      })

    var feed = new InstaFeed({
      // get: 'tagged',
      // tagName: 'awesome',
      accessToken: '21554273.1677ed0.7884c120194e47e183ed2c4dac06cca8',
      get: 'user',
      userId: '21554273',//'182102106',
      mock: true,
      success: (images) => {
        this.insta = images.data
        this.filterDatas()
        // return images;
      }
    });
    feed.run();

  },
};
</script>
